import React from 'react'

export const ErrorPage = () => {
    return (
        <div>
            Error page
        </div>
    )
}
